import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {debounceTime, Subject, Subscription} from 'rxjs';
import {MatSort} from '@angular/material/sort';
import {initializedPageableParameter, PageableParam, SearchFieldsDtoInput} from 'src/app/interfaces/global.interface';
import {PaginationService} from 'src/app/services/pagination.service';
import {SettingsService} from 'src/app/services/settings.service';
import {AllDetailsComponentComponent} from 'src/app/shared/all-details-component/all-details-component.component';
import {CLICK_RESET_TIME, SECRECT_CLICK_THRESHOLD} from 'src/app/shared/constants/constants';
import {SelectionModel} from "@angular/cdk/collections";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator, PageEvent} from "@angular/material/paginator";

@Component({
  selector: 'app-data-table-hybrid',
  templateUrl: './data-table-hybrid.component.html',
  styleUrls: ['./data-table-hybrid.component.scss']
})
export class DataTableHybridComponent implements OnInit, OnDestroy {

  @Input() tableData: any;
  @Input() isPageable = false;
  @Input() searchable = true;
  @Input() columnHeader;
  @Input() hasActionsColumn = true;
  @Input() hasCheckBoxColumn = false;
  @Input() translateColumns = false;
  @Input() hidePaginator=false;
  @Input() isKiosk=false;
  @Input() searchAcrossPages = false;
  @Input() translatableColumns: string[] = [];
  @Input() ellipsisCount: number = 0;
  @Input() paginationEntity: string = null;
  objectKeys = Object.keys;
  listData: MatTableDataSource<any>;
  searchKey: string;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ContentChild(TemplateRef, {static : true}) actions: TemplateRef<any>;
  subscriptions: Subscription = new Subscription();
  actionColumn: boolean;

  pageSize:number = 10;
  dataLength:number;
  pageSizeOptions:number[];

  @Input() searchFields: SearchFieldsDtoInput[];

  @Input() searchDelayTime: number = 0;

  @Output() pageable = new EventEmitter<PageableParam>();
  @Output() searchKeyChange = new EventEmitter<string>();

  @Output() selectionChange = new EventEmitter<any>();
  selection = new SelectionModel<any>(true, []);

  @Input() currentSort = {sortBy:"id", sortDirection:'DESC'}
  currentSearch = null;
  pageParam:any = initializedPageableParameter;

  private searchSubject: Subject<string> = new Subject<string>();


  constructor(
    private paginationService:PaginationService,
    private settingsService:SettingsService,
  ) {
    // Subscribe to the searchSubject and debounce the input
    this.searchSubject.pipe(
      debounceTime(300) // Wait for 300ms pause in events
    ).subscribe(value => {
      this.searchKey = value;
      this.filterTable(); // Call the method to filter or search based on the new value
    });
  }


  ngOnInit() {
    this.actionColumn = this.hasActionsColumn;
    this.subscriptions.add(
      this.tableData?.subscribe(data => {
        this.listData = new MatTableDataSource(data);
        this.listData.sort = this.sort;

        if(!this.isPageable) this.listData.paginator = this.paginator;

        else{
          let page = this.paginationService.getPage(this.paginationEntity);
          if(page) {
            this.dataLength = page.totalElements;
            // this.pageSize = page.size;
          }
        }

        this.pageSize = 10;
        this.pageSizeOptions = [10, 50, 100, 250]
      })
    );

    this.subscriptions.add(
      this.selection.changed.subscribe((selectedRow) => {
        if (selectedRow) {
          console.log(selectedRow)
          const action = selectedRow?.removed.length==0 ?'ADD':'REMOVE';
          this.selectionChange.emit({action, selected: action==='ADD'? selectedRow.added[0]: selectedRow.removed[0]});
        }
      })
    );

  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


  sortChange(e) {
    this.currentSort = { sortBy:e.active, sortDirection:e.direction}
    this.handlePage();
  }


  filterTable() {
    this.listData.filter = this.searchKey.trim().toLowerCase();
    if(this.searchKey) this.currentSearch = this.searchFields.map(field => {
      return {...field, fieldValue:this.searchKey}
    })
    this.handlePage(null, true)
  }

  searchTimeout: any
  isTyping: boolean = false

  onSearchChange(value: string): void {
    if (!this.searchAcrossPages) {
      this.searchSubject.next(value);
      return
    }

    this.isTyping = true
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      this.isTyping = false
      this.searchKeyChange.emit(this.searchKey)
    }, 1500)
  }


  timerRunning: boolean;
  delayedFilter(){
    if(this.timerRunning) return;
    this.timerRunning = true;

    let timer = setTimeout(()=>{
      this.filterTable();
      this.timerRunning = false;
    },this.isPageable? this.searchDelayTime:0);
  }


  onSearchClear() {
    this.searchKey = '';
    this.filterTable();
  }


   handlePage(e?: PageEvent, isSearch = false) {
    if(!this.isPageable) return

     if(e){
      this.pageParam =  {
        ...this.pageParam,
        first: e.pageIndex,  //practically this should be named page
        size: e.pageSize,
      }
     }

     this.pageParam = {...this.pageParam, ...this.currentSort, searchFields: this.currentSearch}
     if(!this.searchKey && this.pageParam.searchFields || !this.currentSearch) delete this.pageParam.searchFields;

     this.pageable.emit({...this.pageParam, isSearch})
   }


   trigger = 0;
   triggerTimer;
   // @ts-ignore
  viewDetails(data){
      if(++this.trigger < SECRECT_CLICK_THRESHOLD) return false;
      if(!this.triggerTimer) this.triggerTimer = setInterval(()=>{this.trigger=0},CLICK_RESET_TIME)

      this.settingsService.openDialogModal({
        component: AllDetailsComponentComponent,
        width: '70%',
        panelClass: ['full-screen-dialog'],
        height: '100%',
        position: { top: '0', right: '0' },
        // width: '70%',
        // height: '90%',
        data: data,
      });
  }
}
